/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Collection methods
 * -----------------------------------------------------------------------------
 *
 * @namespace collection
 */

import axios from 'axios';

var collectionMethods = {
  data: function data() {
    return {
      collection: {
        title: null,
        description: null,
        image: null,
        products: [],
        selectLawnSize: true,
        selectTraySize: true,
        selectBundleSize: true
      }
    };
  },


  methods: {
    _initCollection: function _initCollection() {

      // stop parsing if we are not in the collection template
      if (app.currentTemplate !== 'collection') {
        return;
      }

      $('[data-readmore]').on('click', function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'none';
      });
      $('[data-readless]').on('click', function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'block';
      });

      // check collection section settings => enable ajax filters
      $(app.selectors.productObj).each(function (index, item) {
        var productObj = $(item).html();
        var productData = JSON.parse(productObj);
        var product = productData.product;
        var optionsWithValues = productData.options_with_values;
        product.current_variant = product.variants[0];
        product.options_with_values = optionsWithValues;

        // assign the product cart limit
        product.tags.forEach(function (tag) {
          if (tag.match('cart-limit')) {
            var cartLimit = tag.replace('cart-limit-', '');
            product.cart_limit = parseFloat(cartLimit);
          }
        });

        product.description_short = productData.description;
        app.collection.products.push(product);
      });
    },
    _getcollectionInfo: function _getcollectionInfo() {
      var url = window.location.href.replace(window.location.search, '');
      url += '?view=json';

      axios.get(url).then(function (response) {
        if (response.data) {
          app.collection.title = response.data.title;
          app.collection.description = response.data.body_html;
          app.collection.image = response.data.image;
        }
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _initCollectionDropdown: function _initCollectionDropdown(ele, e) {
      try {
        var id = null;

        var type, optionTitle, var1, var2, selEle, size;
        var html1 = void 0,
            html2 = void 0;
        if (!$(e.target).find('option:selected').text().includes('Select Size')) {
          // if select size is not active
          id = $(e.target).find('option:selected').attr('data-id');
          type = $(e.target).attr('data-coll-dropdown');
          optionTitle = $(e.target).find('option:selected').text();
          if (type == 'Lawns') {
            app.collection.selectLawnSize = false;
          } else if (type == 'Trays') {
            app.collection.selectTraySize = false;
          } else if (type == 'Bundles') {
            app.collection.selectBundleSize = false;
          }
          size = $(e.target).find('option:selected').attr('data-size');
          if (size !== 'xl-flex-tray') {
            html1 = $('[data-new-type-prds][data-title="' + size + '"][data-type="DoggieLawn"]').html();
          } else {
            html1 = $('[data-new-type-prds][data-title="xl"][data-type="DoggieLawn"]').html(); // ad xl lawn for flex tray as well
          }
          html2 = $('[data-new-type-prds][data-title="' + size + '"][data-type="Tray"]').html();

          if (html1 != undefined) {
            var1 = JSON.parse(html1.trim());
          }
          if (html2 != undefined) {
            // for flex tray
            var2 = JSON.parse(html2.trim());
          }
        } else {
          // if select size is  active
          selEle = $($(e.target).find('option')[1]);
          id = selEle.attr('data-id');
          type = $(e.target).attr('data-coll-dropdown');
          optionTitle = selEle.text();
          if (type == 'Lawns') {
            app.collection.selectLawnSize = true;
          } else if (type == 'Trays') {
            app.collection.selectTraySize = true;
          } else if (type == 'Bundles') {
            app.collection.selectBundleSize = true;
          }
        }
        var prdId = $(e.target).attr('data-id');
        var currentVariant;
        $(app.collection.products).each(function (i, prd) {
          if (prd.id == prdId) {
            currentVariant = app.collection.products[i].variants.filter(function (item) {
              return item.id == id;
            });
            app.collection.products[i].current_variant = currentVariant[0];
            if (type == 'Lawns' && var1 != undefined) {
              app.collection.products[i].LawnVariantId = var1.variant_id;
            } else if (type == 'Trays' && var2 != undefined) {
              app.collection.products[i].TrayVariantId = var2.variant_id;
              var shipRate = var2.tags.filter(function (tag) {
                return tag.indexOf('fixedshipping') > -1;
              });
              app.collection.products[i].TrayShippingRate = shipRate[0];
            } else if (type == 'Bundles' && var1 != undefined && var2 != undefined) {
              app.collection.products[i].LawnVariantId = var1.variant_id;
              app.collection.products[i].TrayVariantId = var2.variant_id;
            }
          }
        });
      } catch (error) {
        // Rollbar.error('Something went wrong in variant selection');
      }
    },
    _initVariantDropdown: function _initVariantDropdown(ele, e) {
      try {
        var prdiD, varid, avl, currentVariantLawn;
        if (e != null) {
          // on change
          prdiD = $(e.target).find('option:selected').attr('data-prd-id');
          varid = $(e.target).find('option:selected').attr('data-id');
          avl = $(e.target).find('option:selected').attr('data-available');
          if (avl == 'false' || avl == undefined) {
            $(e.target).closest('.card-product').find('[data-var-add-to-cart]').prop('disabled', 'disabled').text('Unavailable');
          } else {
            $(e.target).closest('.card-product').find('[data-var-add-to-cart]').prop('disabled', false).text('Add to Cart');
          }
        }
        $(app.collection.products).each(function (i, prd) {
          if (prd.id == prdiD) {
            currentVariantLawn = app.collection.products[i].variants.filter(function (item) {
              return item.id == varid;
            });
            app.collection.products[i].current_variant = currentVariantLawn[0];
            if (app.collection.products[i].current_variant.featured_image != null) {
              app.collection.products[i].featured_image = app.collection.products[i].current_variant.featured_image.src;
            }
          }
        });
      } catch (error) {
        // Rollbar.error('Something went wrong in variant selection');
      }
    }
  }
};

export default collectionMethods;